AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Views", "Base");

AoPS.Alcumus.Views.Base = (function (AlcVBase) {
	// Dependencies
	var compileTemplate = AoPS.View.compileTemplate;
	var BbExtras = AoPS.BackboneExtras;
	var Ui = AoPS.Ui;
	var Modal = AoPS.Ui.Modal;
	var LoadUtils = AoPS.LoadUtils;
	var AlcUrl = AoPS.Alcumus.Url;

	// Allow AlcUrl.getUrl to be used directly in Handlebars templates.
	Handlebars.registerHelper("alcurl", _.bind(AlcUrl.getUrl, AlcUrl));

	// Handlebars helper for constructing the Aops scrollbar HTML structure.
	Handlebars.registerHelper("AOPSSCROLL", function (outer_classes, options) {
		// outer_classes is optional. These are class names attached to the
		// outer wrapper (aops-scroll-outer).
		if (arguments.length <= 1) {
			// No outer_classes argument given; it should be options instead.
			options = outer_classes;
			outer_classes = "";
		}

		outer_classes = (outer_classes + " aops-scroll-outer").trim();
		return (
			'<div class="' +
			outer_classes +
			'">' +
			'<div class="aops-scroll-bar">' +
			'<div class="aops-scroll-slider"></div>' +
			"</div>" +
			'<div class="aops-scroll-inner">' +
			'<div class="aops-scroll-content">' +
			options.fn(this) +
			"</div>" +
			"</div>" +
			"</div>"
		);
	});

	// Partial for quest badges
	$(function () {
		Handlebars.registerPartial(
			"quest-badge",
			compileTemplate("#alc-tpl-quest-badge")
		);
	});

	// Given data with an error, compute the footer to display on error pages.
	AlcVBase.getErrorFooter = function (data) {
		// Some revisions made near launch after folding some of this advice into
		// our standard error messages.
		if (data.error_code === "E_UNREGISTERED") {
			return (
				"Please either sign in or register a new account with our " +
				"website by using the links in the top right."
			);
		} else if (data.error_code === "E_SESSION_ENDED") {
			return "Please sign back in using the links in the top right before continuing.";
		} else if (data.zero_load) {
			// Very first load failed.
			return ""; // 'Please wait for awhile, refresh the page, and try again. ' +
			// 	'If problems continue, contact ' +
			// 	'Art of Problem Solving and report that you are unable to use Teacher Tools.';
		} else if (data.should_refresh) {
			return "It is highly recommended that you refresh the page by typing F5.";
			// 'If problems continue, contact ' +
			// 'Art of Problem Solving and report what you are trying to do and ' +
			// 'what problems you are experiencing.';
		} else {
			return ""; // 'Please try again later. If problems continue, contact ' +
			// 	'Art of Problem Solving and report what you are trying to do and ' +
			// 	'what problems you are experiencing.';
		}
	};

	// Show a hard-coded error message if appropriate. Return truey if a
	// message was shown and falsy if the standard handler should show a message.
	AlcVBase.showSpecialError = function (data, modal_params) {
		var error_code = data.error_code;
		modal_params = modal_params || {};

		if (error_code === "E_UNREGISTERED") {
			Ui.buildLoginConfirm(
				"In order to use this part of Alcumus, " +
					"you must have registered an account and be signed in. " +
					"Account registration and Alcumus are both completely free.",
				modal_params
			);
		} else if (error_code === "E_NOT_INITIALIZED") {
			AoPS.Initialize.display({escapable: true});
		} else if (error_code === "E_SESSION_ENDED") {
			Modal.closeAllModals();
			Ui.buildLoginConfirm(
				"Regrettably, your sign in session on our site " +
					"has expired, so we were unable to process your last action. Please " +
					"use the button below to sign back in, then retry what you just did.",
				modal_params
			);
		} else if (error_code === "E_NOT_READY") {
			Modal.closeAllModals();
			Modal.showAlert(
				data.error_msg,
				_.extend(modal_params, {
					onClose: function () {
						window.location.reload();
					},
				})
			);
		} else if (error_code === "E_SAME_RESPONSE") {
			Modal.showAlert(
				"You already submitted this answer before. " +
					"Alcumus won't count it wrong again, so you still have another shot. " +
					"Keep trying!",
				modal_params
			);
		} else if (error_code === "E_NO_GIVEUP") {
			Modal.showAlert(
				"Alcumus doesn't allow you to give up on problems until " +
					"you have submitted at least one incorrect answer. " +
					"Give this problem your best attempt before you raise " +
					"the white flag.",
				modal_params
			);
		} else if (error_code === "E_NO_SYNC") {
			Modal.showAlert(
				"Your browser and the Art of Problem Solving server " +
					"are not in agreement on what problem you should have. " +
					"Refresh the page, and make sure you do not use Alcumus " +
					"in multiple windows or tabs at the same time.",
				modal_params
			);
		} else if (error_code === "E_ABANDON_LIMIT_EXCEEDED") {
			Modal.showAlert(
				"You have abandoned too many quests today. " +
					"You will need to wait until tomorrow before you can abandon another.",
				modal_params
			);
		} else if (error_code === "E_FOCUS_CHANGE_OVERRIDE") {
			// Occurs when multiple change focus requests come in and one didn't get
			// to start or finish. Return true here without showing an error.
			return true;
		} else {
			// Nothing special done. Use default handling.
			return false;
		}
		return true;
	};

	// Throw up an error message on a modal. base is a string representing the
	// start of the error message, usually describing what action caused the
	// error. data is the usual error data. modal_params is an object with
	// options for the modal itself, a la AoPS.Modal.
	AlcVBase.showModalError = function (base, data, modal_params) {
		modal_params = modal_params || {};
		var showed_spec_error = AlcVBase.showSpecialError(data, modal_params);
		if (showed_spec_error) {
			return;
		}

		base = base ? base + " " : "";

		var data_error = data.error_msg;
		data_error = data_error ? data_error + " " : "";

		var footer = AlcVBase.getErrorFooter(data);

		Modal.showAlert(base + data_error + footer, modal_params);
	};

	// If any of the given matched elements have focus, pressing the enter key
	// should trigger the provided handler (with optional bound context).
	// Convenience for the appropriate $.on call. Returns the event handler
	// function object to make it easier to use $.off later.
	AlcVBase.bindEnterKey = function ($els, handler, context, options) {
		if (context) {
			handler = _.bind(handler, context);
		}
		options = options || {};

		function onKeyPress(evt) {
			// Don't forward the key press if a modal is up.
			if (Modal.isModalVisible()) {
				return;
			}
			// Don't forward the key press if the user is doing things in the Feed topic view.
			var focused = $(document.activeElement);
			if (focused.parents("#feed-topic").length) {
				return;
			}

			var is_enter = evt.keyCode === 13;
			var has_ctrl = evt.ctrlKey;
			if (evt.keyCode === 10) {
				is_enter = true;
				has_ctrl = true;
			}
			if (is_enter && !!options.with_ctrl === !!has_ctrl) {
				evt.preventDefault();
				handler(evt);
			}
		}
		$els.on("keypress", onKeyPress);

		return onKeyPress;
	};

	// Build an AoPS scrollbar on the given element. Options is an optional
	// object with fade, always_show, onScroll keys.
	AlcVBase.buildScrollbar = function (base_el, options) {
		// var ALC_SCROLL_MOUSEWHEEL_SPEED = 16;
		var params = {
			$scrollbar: base_el.find(".aops-scroll-bar"),
			$content: base_el.find(".aops-scroll-content"),
			// mousewheel_speed : ALC_SCROLL_MOUSEWHEEL_SPEED,
			show_on_hover: true,
			autosize: true,
		};

		options = options || {};

		// if (options.fade) {
		// 	_.extend(params, {
		// 		fade_start_class : 'aops-scroll-fade-top alc-scrollarea-fade',
		// 		fade_end_class : 'aops-scroll-fade-bottom alc-scrollarea-fade'
		// 	});
		// }

		if (options.always_show) {
			delete params.show_on_hover;
		}

		if (options.onScroll) {
			params.onScroll = options.onScroll;
		}

		AoPS.Ui.buildAopsScrollbar(params);
	};

	// The base Alcumus view, using the BbExtras template and subview code among
	// other methods.
	var base_view = _.extend({}, BbExtras.TemplateMixin, BbExtras.SubviewMixin, {
		COLLECTION_CHANGE: " add remove reset sort ",

		// Called before any template rendering and subview injection.
		// No-op by default; override in derived classes
		preRender: function () {},

		// Return the context for the Handlebars template.
		getContext: function () {
			// Override in derived classes
			return {};
		},

		// Call this method to render any MathJax inside the view. Optionally
		// provide a callback that is fired when rendering finishes.
		processMathJax: function (callback) {
			if (window.MathJax) {
				callback = callback || function () {};
				MathJax.Hub.Queue(["Typeset", MathJax.Hub, this.el], [callback]);
			}
		},

		// If you have code that needs to wait for a view to render before
		// executing, wrap that code in a callback and send it to this
		// function.
		whenRendered: function (callback, context) {
			callback = LoadUtils.makeCallback(callback, context);
			if (this.rendered) {
				setTimeout(callback, 0);
			} else {
				this.render_callbacks = this.render_callbacks || [];
				this.render_callbacks.push(callback);
			}
		},

		// Internal function for managing render callbacks.
		setRendered: function (new_val) {
			this.rendered = !!new_val;
			if (new_val && this.render_callbacks && this.render_callbacks.length) {
				setTimeout(
					_.bind(function () {
						_.each(this.render_callbacks, function (cb) {
							cb();
						});
						this.render_callbacks = [];
					}, this),
					0
				);
			}
		},

		// The standard rendering procedure, handling subviews and templates.
		// Do not override this in derived classes; override preRender or
		// postRender to inject appropriate behavior.
		render: function () {
			this.preRender();
			this.detachAllSubviews();
			this.renderTemplate(this.getContext());
			this.attachAllSubviews();
			this.removeHandlebarsLocationMarkers();
			this.postRender();
			this.setRendered(true);
		},

		// An alternative to render, when the element should simply display a
		// piece of given HTML.
		renderSimple: function (html) {
			this.detachAllSubviews();
			this.renderTopOnly();
			this.$el.html(html || "");
			this.setRendered(true);
		},

		// An alternative to render, when the element is not ready and should
		// display a loading indicator. Optionally, provide HTML for the loader;
		// otherwise a suitable default is used.
		renderLoading: function (loader) {
			this.renderSimple();
			loader = _.isUndefined(loader) ? AoPS.Page.$loader.clone() : loader;
			this.$el.append(loader || "");
			this.setRendered(false);
		},

		// An alternative to render, when the element can't be displayed and
		// should throw an error panel up. Provide the error data.
		renderError: function (data) {
			if (_.contains(["E_UNREGISTERED", "E_SESSION_ENDED"], data.error_code)) {
				// Need to show the login dialog here
				AlcVBase.showSpecialError(data);
				this.renderSimple(this.getErrorBox(data));
			} else {
				this.renderSimple(this.getErrorBox(data));
			}
			this.setRendered(false);
		},

		getErrorBox: function (data) {
			var intro = data && data.intro;
			var error_msg = data && data.error_msg;
			var errorBoxTpl = compileTemplate("#alc-tpl-error-box");

			return errorBoxTpl({
				intro: intro || "",
				error_msg: error_msg || "",
				footer: AlcVBase.getErrorFooter(data),
			});
		},

		// Called after any template rendering and subview injection.
		// No-op by default; override in derived classes
		postRender: function () {},

		// Default behavior for closing this view. If overridden, make sure to
		// call these methods too.
		onClose: function () {
			this.stopListening();
			this.closeAllSubviews();
			this.setRendered(false);
		},
	});
	AlcVBase.BaseView = AoPS.View.extend(base_view);

	// A placeholder view; can be used in development for unfinished parts.
	AlcVBase.Placeholder = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-placeholder");

			this.classes = options.classes || [];

			this.render();
		},

		postRender: function () {
			this.$el.addClass(this.classes.join(" "));
		},
	});

	// A template for Grid container views, as they have shared loading patterns.
	AlcVBase.GridContainer = AlcVBase.BaseView.extend({
		initialize: function (options) {
			// Placeholder, but make sure the following are always defined:

			this.class_id = options.class_id;
			this.class_model = this.model.get("classes").get(this.class_id);

			this.topic_id = options.topic_id;
			this.problem_id = options.problem_id;

			// Then call this:
			this.loadAndRenderAlcumusContainer();
		},

		// Load topic, problem, or just render Alcumus.
		loadAndRenderAlcumusContainer: function () {
			if (this.problem_id) {
				// Attempt to initialize with problem.
				this.initializeWithProblem();
			} else if (this.topic_id) {
				// Or, attempt to initialize with topic.
				this.initializeWithFocusTopic();
			} else {
				// Otherwise, just start drawing.
				this.handleRender(true, {});
			}
		},

		// Since problem id has been set, call loadProblemInClass (in alc_models_user.js)
		initializeWithProblem: function () {
			if (this.topic_id) {
				// If it is necessary to set topic at the same time, we do that first.
				var topic_model = this.model.get("topics").get(this.topic_id);
				var new_focus = this.model.getFocusAsObject(
					topic_model,
					this.class_model
				);

				if (new_focus) {
					// We set the new focus, yippee!!!
					this.model.changeFocus(
						new_focus,
						_.bind(function (ok, data) {
							if (!ok && data.error_code !== "E_AJAX_FILTERED") {
								// See below as to why we ignore E_AJAX_FILTERED.
								this.renderError(data);
							} else {
								// Load the problem now.
								this.model.loadProblemInClass(
									this.problem_id,
									this.class_id,
									_.bind(this.handleRender, this)
								);
							}
						}, this),
						{
							context: this,
						}
					);
					return;
				}
			}

			// Go ahead and load the problem.
			this.model.loadProblemInClass(
				this.problem_id,
				this.class_id,
				_.bind(this.handleRender, this)
			);
		},

		// Since topic id has been set, call changeFocus (in alc_models_user.js)
		initializeWithFocusTopic: function () {
			var topic_model = this.model.get("topics").get(this.topic_id);
			var new_focus = this.model.getFocusAsObject(
				topic_model,
				this.class_model
			);
			this.model.changeFocus(new_focus, _.bind(this.handleRender, this), {
				context: this,
			});
		},

		// Supposed to be usable for an AJAX callback, hence (ok, data) form
		handleRender: function (ok, data) {
			if (!ok && data.error_code !== "E_AJAX_FILTERED") {
				/**
				 * E_AJAX_FILTERED happens a fair amount in Alcumus because Alcumus doesn't let
				 * the same thing happen multiple times, especially when Alcumus first loads,
				 * so we only render an error message non-filtered errors.
				 */
				this.renderError(data);
			} else {
				// Show things.
				this.createSubviews();
				this.render();
			}
		},

		createSubviews: function () {
			// Placeholder. Please extend.
		},
	});

	return AlcVBase;
})(AoPS.Alcumus.Views.Base);
